import ErrorNotifier, { Severity } from 'app/scripts/services/error-notifier';
import { TDispatch, TGetState } from 'state';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import { Appearance, Folder, Message } from '../types';
import rejectMessages from '../../api/reject';
import { getSuccessAndFailedItems, Options } from './approve-items';
import { rejectItemsFailure, rejectItemsStart, rejectItemsSuccess } from '.';

const defaultOptions: Options = {
  appearance: Appearance.COLLAPSED,
  fromKeyboard: false
};

const rejectItems = (messages: Message[] = [], options: Options = defaultOptions) => {
  return async (dispatch: TDispatch, getState: TGetState) => {
    const { appearance } = options;
    const messageIds: string[] = messages.map((message: Message) => message.get('id'));

    dispatch(rejectItemsStart({ messageIds, appearance, folder: Folder.BLOCKED }));

    try {
      const { isModerationMode, pageInfo } = getState().moderation.messages;
      const usePrefix = isModerationMode && pageInfo.folder === Folder.PENDING;

      const { results } = await rejectMessages(messageIds, usePrefix);

      const [successItems, failedItems] = getSuccessAndFailedItems(messageIds, results);

      if (successItems.length) {
        dispatch(
          rejectItemsSuccess({ messageIds: successItems, appearance, folder: Folder.BLOCKED })
        );
      }

      if (failedItems.length) {
        AnalyticsProvider.track('message reject error', { message_ids: messageIds });
        ErrorNotifier.notifyError('Message Approved Failed: Unresolved Messages from BED', {
          message_ids: failedItems,
          level: Severity.Critical
        });
        dispatch(
          rejectItemsFailure({
            messageIds: failedItems,
            error: new Error('UnresolvedMessagesOnBED')
          })
        );
      }
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError('Message Reject Failed', {
        message_ids: messageIds,
        level: Severity.Critical
      });
      AnalyticsProvider.track('message reject error', { message_ids: messageIds });
      dispatch(rejectItemsFailure({ messageIds, error }));
    }
  };
};

export default rejectItems;
